module.exports = __webpack_public_path__ + "static/media/ico-social03.50d0dd09.svg";